import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import socket from '@/socket/socket';
import { updateStateOnUpdateItemById, updateStateOnAddItemById, updateStateOnDeleteItemById } from '@/redux/actions';

export const useItemRealtime = ({ customerId }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!customerId) {
            return;
        }

        const handleItemChanged = ({ id, action }) => {
            console.log('<<<Item changed:', id, customerId, action);

            if (action === 'UPDATE') {
                dispatch(updateStateOnUpdateItemById(id));
            } else if (action === 'CREATE') {
                dispatch(updateStateOnAddItemById(id));
            } else if (action === 'DELETE') {
                dispatch(updateStateOnDeleteItemById(id));
            }
        };

        socket.on('item:changed', handleItemChanged);

        return () => {
            socket.off('item:changed', handleItemChanged);
        };

    }, [customerId, dispatch]);
};